import Column from '@components/Column';
import styled from '@emotion/styled';
import { Link } from '@stackflow/link';

import AllIcon from './AllIcon';

function AllButton() {
    return (
        <Link activityName='MyMenuActivity'
            activityParams={{}}>
            <Column spacing={6} align='center'>
                <Icon/>
                <Label>
                    전체보기
                </Label>
            </Column>
        </Link>
    );
}

const Icon = styled(AllIcon)`
    min-width: 32px;
`;

const Label = styled.button`
    background-color: var(--color-gray6);
    border-radius: 20px;
    color: var(--color-white);
    font-size: 14px;
    line-height: 20px;
    padding: 3px 10px;
    white-space: nowrap;
`;

export default AllButton;
